import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ReportDom from "../../../components/common/ReportDom";
import SalesReturnVoucherBody from "./SalesReturnVoucherBody";
import SalesReturnVoucherBodyDesignA from "./SalesReturnVoucherBodyDesignA";
import { fetchSingleInstitutionDetails } from "../../../store/commonThunks/lookups";

export default function SalesReturnPrint({ id }) {
  const [ready, setReady] = useState(false);
  const dispatch = useDispatch();
  const { institutionData } = useSelector((state) => state.lookups);
  const isDesignA = institutionData?.print_template === "design_a";

  // Standalone print route (via PrintRenderer, a fresh tab/page load) --
  // institutionData.print_template can't be assumed already loaded.
  useEffect(() => {
    dispatch(fetchSingleInstitutionDetails()).finally(() => setReady(true));
  }, [dispatch]);

  if (!ready) return null;

  if (isDesignA) {
    return <ReportDom mode="no-title" renderTable={() => <SalesReturnVoucherBodyDesignA sale_r_id={id} />} />;
  }
  return (
    <ReportDom
      renderTable={() => <SalesReturnVoucherBody sale_r_id={id} printMode />}
    />
  );
}
